import React from 'react';
import { Box, type BoxProps } from '@mui/material';
import { adminCombineSx, adminSurfaceSx } from '../../styles/adminComponentStyles';

type AdminSurfaceProps = BoxProps;

const AdminSurface: React.FC<AdminSurfaceProps> = ({ children, sx, ...props }) => (
  <Box sx={adminCombineSx(adminSurfaceSx, sx)} {...props}>
    {children}
  </Box>
);

export default React.memo(AdminSurface);
